import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';
import { FeatureRow } from './FeatureRow';

export const FeatureList = ({ productId }: { productId: string }) => {
  const { data: product } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      { productId },
    );

  return (
    <ProductCardList.Default.Card.FeatureList
      marginTop="SP6"
      boxSizing="border-box"
      gap="16px"
      verticalAlign="top"
      renderRow={(row) => <FeatureRow row={row} />}
      features={product?.features ?? []}
    />
  );
};
